import Event from './Event';

class DestroyedEvent extends Event {}

export default DestroyedEvent;
